var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"thick-border"},[_c('h4',[_vm._v(_vm._s(_vm.level.name))]),_c('router-link',{staticClass:"button block-button",attrs:{"to":{name: 'Game', params: {levelID: this.level.id}}}},[_vm._v(" Play ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }